<script setup>
import { computed, onBeforeMount, shallowRef, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import ToastApp from "@/components/ToastApp.vue";
import ConfirmModal from "@/components/common/modal/ConfirmModal.vue";
import { useConfirm } from "@/composables/common/useConfirm";
import { layouts } from "@/utils/lists/layouts";

const store = useStore();
const route = useRoute();
const layout = shallowRef(layouts.AuthLayout);
const isWithoutLayout = ref(false);

const {
  isOpen: isConfirmOpen,
  options: confirmOptions,
  accept: acceptConfirm,
  cancel: cancelConfirm,
} = useConfirm();

const isConfirmDescriptionRendered = computed(
  () => typeof confirmOptions.value.description === "function",
);

watch(route, () => {
  isWithoutLayout.value = route?.meta?.layout === "none";
  cancelConfirm();
});

onBeforeMount(async () => {
  let tenantName;
  try {
    const localUser = localStorage.getItem("localUser");
    if (localUser) {
      const parsed = JSON.parse(localUser);
      tenantName = parsed.tenantName;

      // TODO: move to Pinia. Also move to `main.js` file
      store.commit("setTenantName", tenantName);
      layout.value = layouts.DefaultLayout;
    }
  } catch (error) {
    console.error(error);
  }

  store.state.isTransparent = "bg-transparent";
});
</script>

<template>
  <ToastApp />

  <ConfirmModal
    v-model:is-open="isConfirmOpen"
    :title="confirmOptions.title"
    :confirm-label="confirmOptions.confirmLabel"
    :cancel-label="confirmOptions.cancelLabel"
    :confirm-style="confirmOptions.confirmStyle"
    @confirm="acceptConfirm"
    @cancel="cancelConfirm"
  >
    <component
      :is="confirmOptions.description"
      v-if="isConfirmDescriptionRendered"
    />
    <template v-else>{{ confirmOptions.description }}</template>
  </ConfirmModal>

  <router-view v-if="isWithoutLayout" />
  <component v-else :is="layout" />
</template>
